export const getErrorMessage = (error: any): string => {
  if (!error) return 'An error occurred';

  if (typeof error === 'string') return error.replace(/\s+/g, ' ').trim();

  if (typeof error === 'object') {
    if (typeof error.error === 'string') {
      return error.error.replace(/\s+/g, ' ').trim();
    }
    if (typeof error.detail === 'string') {
      return error.detail.replace(/\s+/g, ' ').trim();
    }
    if (typeof error.message === 'string') {
      return error.message.replace(/\s+/g, ' ').trim();
    }

    for (const value of Object.values(error)) {
      if (Array.isArray(value) && typeof value[0] === 'string') {
        return value[0];
      }
      if (typeof value === 'string' && value) {
        return value;
      }
    }
  }

  return 'An error occurred';
};
